module.exports = __webpack_public_path__ + "static/media/banner.e0f236ab.svg";